import Vue from 'vue'

const state = {
    audios: [],
    status: 'stopped',
    show_modal: false,
    search: '',
    progress: 'all',
    favorite: 'all',
    selected_areas: [],
    selected_groups: [],
    progress_audio: {},
    playlist: [],
    type_list: ''
}

const actions = {
    SET_AUDIOS(context, [audios]) {
        context.commit('SAVE_AUDIOS', [audios])
    },

    SET_STATUS(context, [status]) {
        context.commit('SAVE_STATUS', [status])
    },

    SET_MODAL(context, [show_modal]) {
        context.commit('SAVE_MODAL', [show_modal])
    },

    SET_FILTERS(context, [search, progress, favorite, selected_areas, selected_groups]) {
        context.commit('SAVE_FILTERS', [search, progress, favorite, selected_areas, selected_groups])
    },

    SET_PROGRESS(context, [progress_audio]) {
        context.commit('SAVE_PROGRESS', [progress_audio])
    },

    SET_PROGRESS(context, [progress_audio]) {
        context.commit('SAVE_PROGRESS', [progress_audio])
    },

    SET_PLAYLIST(context, [playlist]) {
        context.commit('SAVE_PLAYLIST', [playlist])
    },
    
    SET_TYPE_LIST(context, [type_list]) {
        context.commit('SEVE_TYPE_LIST', [type_list])
    },
}

const mutations = {
    SAVE_AUDIOS: (state, [audios]) => {
        Vue.set(state, 'audios', audios)
        if (audios.length > 0) Vue.set(state, 'status', 'playing')
    },

    SAVE_STATUS: (state, [status]) => {
        Vue.set(state, 'status', status)
    },

    SAVE_MODAL: (state, [show_modal]) => {
        Vue.set(state, 'show_modal', show_modal)
    },

    SAVE_FILTERS: (state, [search, progress, favorite, selected_areas, selected_groups]) => {
        Vue.set(state, 'search', search)
        Vue.set(state, 'progress', progress)
        Vue.set(state, 'favorite', favorite)
        Vue.set(state, 'selected_areas', selected_areas)
        Vue.set(state, 'selected_groups', selected_groups)
    },

    SAVE_PROGRESS(state, [progress_audio]){
        Vue.set(state, 'progress_audio', progress_audio)
    },

    SAVE_PLAYLIST(state, [playlist]){
        Vue.set(state, 'playlist', playlist)
    },

    SEVE_TYPE_LIST(state, [type_list]){
        Vue.set(state, 'type_list', type_list)
    }
}

const getters = {
    audios: state => {
        return state.audios
    },

    status: state => {
        return state.status
    },

    show_modal: state => {
        return state.show_modal
    },

    search: state => {
        return state.search
    },

    progress: state => {
        return state.progress
    },

    favorite: state => {
        return state.favorite
    },

    selected_areas: state => {
        return state.selected_areas
    },

    selected_groups: state => {
        return state.selected_groups
    },

    progress_audio: state => {
        return state.progress_audio
    },

    playlist: state => {
        return state.playlist
    },

    type_list: state => {
        return state.type_list
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}